define('presentation/accountManager/bindings/accountManagerCardBinding',[], function () {
    return {
        init: function (element, valueAccessor) {
            const { hideCard } = ko.unwrap(valueAccessor());

            //#region Outside Click Check
            const _checkIfOutsideCardClicked = (/** @type { MouseEvent }*/ event) => {
                /** @type { EventTarget }*/
                let clickedElement = event.target;
                do {
                    if (clickedElement === element) {
                        return;
                    }
                    // Go up the DOM
                    clickedElement = clickedElement.parentNode;
                } while (clickedElement);

                hideCard();
            };
            //#endregion

            document.addEventListener('click', _checkIfOutsideCardClicked);

            ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                document.removeEventListener('click', _checkIfOutsideCardClicked);
            });
        }
    };
});
